module.exports = __webpack_public_path__ + "img/third-prize.7d2a08d8.png";